import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { NavigationExtras, Router } from '@angular/router';
import { OwlOptions, SlidesOutputData } from 'ngx-owl-carousel-o';
import { first } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { BaniListTypes } from 'src/app/core/enum';
import { BaniPost, SignificantTerm, CarouselItem } from 'src/app/core/models';
import { DashboardService } from 'src/app/services/dashboard.service';
import { UtilsService } from 'src/app/services/utils.service';
import { MatDialog } from '@angular/material/dialog';
import { ModalVideoComponent } from '../components';
import {
  GuidedTourService,
  Orientation,
  GuidedTour,
  ProgressIndicatorLocation
} from "ngx-guided-tour";
import { OnboardingSteps } from 'src/app/core/constants';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, AfterViewInit {
  dynamicSlides: CarouselItem[] = [];
  dynamicFeaturedSlides: any = [];
  dynamicUpcomingSlides: any = [];
  significantTerms: SignificantTerm[] = [];
  recentReleases: BaniPost[] = [];
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    autoplay: true,
    autoplayTimeout:10000,
    touchDrag: true,
    pullDrag: false,
    autoHeight: false,
    dots: false,
    navSpeed: 800,
    smartSpeed: 1800,
    navText: ['&#8249', '&#8250;'],
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      760: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
    nav: false,
  };
  activeSlides: SlidesOutputData | undefined;
  isFeaturedLoading: boolean = false;
  isHandsetPortrait: boolean = false;
  isRecentPostsLoading: boolean = false;
  isUpcomingPostsLoading: boolean = false;
  isSignificantTermsLoading: boolean = false;
  isDynamicSlidesLoading: boolean = false;
  @ViewChild('sidenav') sidenavElement: MatDrawer | undefined;
  progressIndicatorLocation = ProgressIndicatorLocation.TopOfTourBlock;
  private readonly TOUR: GuidedTour = {
    tourId: "purchases-tour",
    useOrb: false,
    skipCallback: () => '',
    completeCallback: () => 
      window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    }),
    steps:[]
  };
  constructor(
    private dashboardService: DashboardService,
    private router: Router,
    private _sanitizer: DomSanitizer,
    private utils: UtilsService,
    public dialog: MatDialog,
    private guidedTourService: GuidedTourService,
    private el: ElementRef
  ) { }

  ngOnInit(): void {
    this.fetchCarouselItems();
    this.fetchFeaturedItems();
    this.fetchRecentItems();
    this.fetchUpcomingItems();
    if(sessionStorage.getItem('url')){
      this.startTour();
      sessionStorage.removeItem('url');
    }
  }

  // ngAfterViewChecked() {
  //   const slides = this.el.nativeElement.querySelectorAll('.carousel-text-wrapper');
  //   if (slides.length === 0) {
  //     console.warn('No slides found!');
  //     return;
  //   }
  
  //   const observer = new IntersectionObserver((entries) => {
  //     entries.forEach(entry => {
  //       if (entry.isIntersecting) {
  //         const slide = entry.target as HTMLElement;
  //         const imgUrl = slide.getAttribute('data-bg-url');
  //         if (imgUrl) {
  //           slide.style.backgroundImage = `url('${imgUrl}')`;
  //         }
  //       }
  //     });
  //   }, { rootMargin: '200px' });
  
  //   slides.forEach((slide: HTMLElement) => {
  //     observer.observe(slide);
  //   });
  // }
  
  ngAfterViewInit() {

    this.sidenavElement?.closedStart.subscribe(() => {
      // console.log('closed sidebar');
    });
    this.fetchSignificantTerms();
  }

  getPassedData(data: SlidesOutputData) {
    this.activeSlides = data;
  }

  openVideoPopup(details: any): void {
    if (details?.BaniVideoURL) {
      this.dialog.open(ModalVideoComponent, {
        data: { videoURL:details.BaniVideoURL },
      });
    }
    else{
       this.goToPost(details?.BaniCode)
    }
  }

  /**
   * If BaniVideoURL comes from the backend then use custom logic to extract
   * the thumbnail else return a placeholder
   */
  fetchImageThumbnail(baniItem: any) {
    return baniItem.BaniVideoURL
      ? this.utils.fetchImageThumbnail(baniItem.BaniVideoURL) : (baniItem.BaniImageURL?.trim() ? baniItem.BaniImageURL : '/assets/images/mediaPlaceholder.webp')
  }

  getData(event: SlidesOutputData) {
    // console.log(event);
  }

  carouselClick(slide:CarouselItem){
     console.log(slide)
  
   if (slide.ExternalLink == "True") {
      window.open(slide.BaniURL, '_blank');
    }
    else if(slide.SikhriEventID == '2' || slide.SikhriEventID == '4'){
      let param :NavigationExtras = {queryParams:{
        type:'Keyword',
        keyword: slide.SikhriEventID === '2' ? 'Guru Teghbahadar Sahib' : (slide.SikhriEventID === '4' ? 'Anand Sanskar' : 'Guru Granth Sahib')
        // type:tag.type,
        // keyword:type.tag
      }}
      this.router.navigate(['/search'],param)
      
    }
    else{
      this.router.navigate([slide.BaniURL]);
    }
  }

  fetchCarouselItems() {
    this.isDynamicSlidesLoading = true;
    this.dashboardService
      .fetchCarouselItems()
      .pipe(first())
      .subscribe({
        next: (res: any) => {
          this.isDynamicSlidesLoading = false;
          this.dynamicSlides = res?.value?.length ? res.value : [];
          console.log(this.dynamicSlides);
        },
        error: (e: any) => {
          this.dynamicSlides = [];
          // console.error('error in fetching carousel items', e);
        },
      });
  }

  fetchFeaturedItems() {
    this.isFeaturedLoading = true;

    this.dashboardService
      .fetchFeaturedItems(BaniListTypes.FEATURED)
      .pipe(first())
      .subscribe({
        next: (res: any) => {
          this.isFeaturedLoading = false;
          this.dynamicFeaturedSlides = res?.value?.length ? res.value : [];
        },
        error: (e: any) => {
          this.dynamicFeaturedSlides = [];
          // console.error('error in fetching featured items', e);
        },
      });
  }

  fetchRecentItems() {
    this.isRecentPostsLoading = true;
    this.dashboardService
      .fetchRecentItems()
      .pipe(first())
      .subscribe({
        next: (res: any) => {
          this.isRecentPostsLoading = false;
          this.recentReleases = res?.value?.length ? res.value : [];
        },
        error: (e: any) => {
          this.recentReleases = [];
          // console.error('error in fetching recent carousel items', e);
        },
      });
  }

  fetchUpcomingItems() {
    this.isUpcomingPostsLoading = true;
    this.dashboardService
      .fetchFeaturedItems(BaniListTypes.UPCOMING)
      .pipe(first())
      .subscribe({
        next: (res: any) => {
          this.isUpcomingPostsLoading = false;
          this.dynamicUpcomingSlides = res?.value?.length ? res.value : [];
        },
        error: (e: any) => {
          this.dynamicUpcomingSlides = [];
          // console.error('error in fetching upcoming carousel items', e);
        },
      });
  }

  goToSignificantTerms() {
    this.router.navigate(['/glossary']);
  }

  goToSignificantTermDetail(termName: string) {
    this.router.navigate(['/significant-term-detail', termName]);
  }

  goToPost(baniCode: string) {
    this.router.navigate(['/bani', baniCode]);
  }

  fetchSignificantTerms() {
    this.isSignificantTermsLoading = true;
    this.dashboardService
      .fetchSignificantTerms(this.isHandsetPortrait)
      .pipe(first())
      .subscribe({
        next: (res: any) => {
          this.isSignificantTermsLoading = false;
          this.significantTerms = res?.value?.length ? res.value : [];

          // sort sections in descreasing increasing order by WordID
          this.significantTerms =
            this.significantTerms.sort(
              (a: any, b: any) =>
                a.WordName > b.WordName ? 1 : -1
            );

        },
        error: (e: any) => {
          this.significantTerms = [];
          // console.error('error in fetching significantTerms', e);
        },
      });
  }

  handleSideNav(event: any) { }

  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
    setTimeout(() => {
      this.customOptions = { ...this.customOptions };
      this.guidedSteps()
    }, 200);
  }

  guidedSteps(){
    let currentLanguage = localStorage.getItem('language');
    if (currentLanguage) {
      let onboardingSteps = currentLanguage === 'en' ? OnboardingSteps.en : OnboardingSteps.pa;
      // console.log(this.isHandsetPortrait)
      if(!this.isHandsetPortrait){
      this.TOUR.steps = [
        {
          content: onboardingSteps[0]
        },
        {
          selector: "#searchIcon",
          content: onboardingSteps[1],
          orientation: Orientation.BottomRight,
        },
        {
          selector: "#GuruSahib",
          content: onboardingSteps[2],
          orientation: Orientation.Bottom
        },
        {
          content: onboardingSteps[3],
          selector: "#language",
          orientation: Orientation.BottomRight
        },
        {
          selector: "#project",
          content: onboardingSteps[4],
          orientation: Orientation.Bottom
        },
        {
          selector: "#contact-us",
          content: onboardingSteps[5],
          orientation: Orientation.Top
        },
        {
          content: onboardingSteps[6]
        }
      ]
    }
    else{
      this.TOUR.steps = [
        {
          content: onboardingSteps[0],
        },
        {
          selector: "#searchIcon",
          content: onboardingSteps[1],
          orientation: Orientation.BottomRight,
          action: () => this.sidenavElement?.toggle(),
        },
        {
          selector: "#GuruSahibHandset",
          content: onboardingSteps[2],
          orientation: Orientation.Bottom,
        },
        {
          content: onboardingSteps[3],
          selector:"#languageHandset",
          orientation: Orientation.Bottom
        },
        {
          selector: "#projectHandset",
          content: onboardingSteps[4],
          orientation: Orientation.Bottom
        },
        {
          action: () => this.sidenavElement?.toggle(),
          selector: "#contact-us",
          content: onboardingSteps[5],
          orientation: Orientation.Top
        },
        {
          content: onboardingSteps[6]
        }
      ]
    }
    }
  }

  // stripHTML(html: string) {
  //   let doc = new DOMParser().parseFromString(html, 'text/html');
  //   return doc.body.textContent || '';
  // }

  goToSearch() {
    this.router.navigate(['/search']);
  }

  showSmallerString(descriptionText: string) {
    if (descriptionText) {
      let text = this.utils.stripHTML(descriptionText);
      let result = text.substring(0, 180).lastIndexOf(" ");
      return text.substring(0, result);
    } else {
      return descriptionText;
    }
  }
 showSmallerRecentString(descriptionText: string) {
    if (descriptionText) {
      let text = this.utils.stripHTML(descriptionText);
      let result = text.substring(0, 220).lastIndexOf(" ");
      return text.substring(0, result);
    } else {
      return descriptionText;
    }
  }
  parseAsString(idString: number): string {
    return String(idString);
  }

  convertToSafeURL(videoURL: string): SafeResourceUrl {
    return this._sanitizer.bypassSecurityTrustResourceUrl(videoURL);
  }

  startTour(){
    setTimeout(() => this.guidedTourService.startTour(this.TOUR), 1000);
  }
}
